export const THUMB_WIDTH = '64px';

export const THUMB_HEIGHT = '85px';
